import { render, staticRenderFns } from "./noticeCom.vue?vue&type=template&id=2614aa66&scoped=true"
import script from "./noticeCom.vue?vue&type=script&lang=js"
export * from "./noticeCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2614aa66",
  null
  
)

export default component.exports